import { oz } from '@weft/utils';
import { IngestedMeterSchema } from '../meter';
import { IngestedEventSchema } from './ingested-event-schema';

export const EventFieldExtractorPayloadSchema = oz.union([
  IngestedMeterSchema,
  IngestedEventSchema,
]);

export type EventFieldExtractorPayload = oz.infer<typeof EventFieldExtractorPayloadSchema>;